var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9511 4.45746C13.9511 5.59416 13.123 6.51562 12.1015 6.51562C11.08 6.51562 10.252 5.59416 10.252 4.45746C10.252 3.32076 11.08 2.39929 12.1015 2.39929C13.123 2.39929 13.9511 3.32076 13.9511 4.45746Z",
    stroke: "#64748B",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64642 4.45746C5.64642 5.59416 4.81834 6.51562 3.79684 6.51562C2.77535 6.51562 1.94727 5.59416 1.94727 4.45746C1.94727 3.32076 2.77535 2.39929 3.79684 2.39929C4.81834 2.39929 5.64642 3.32076 5.64642 4.45746Z",
    stroke: "#64748B",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20931 6.70619C4.98349 6.58383 4.78328 6.51521 4.51524 6.51521H3.08487C2.14053 6.51521 1.375 7.36704 1.375 8.41789V9.64258H4.87247",
    stroke: "#64748B",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0282 9.64258H14.5257V8.41789C14.5257 7.36704 13.7602 6.51518 12.8159 6.51518H11.3855C11.1174 6.51518 10.9172 6.58384 10.6914 6.70619",
    stroke: "#64748B",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2965 3.06263C10.2965 4.5053 9.24545 5.6748 7.94899 5.6748C6.65254 5.6748 5.60156 4.5053 5.60156 3.06263C5.60156 1.61997 6.65254 0.450464 7.94899 0.450464C9.24545 0.450464 10.2965 1.61997 10.2965 3.06263Z",
    stroke: "#64748B",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87109 9.64258V8.08821C4.87109 6.75449 5.84269 5.67332 7.0412 5.67332H8.85663C10.0551 5.67332 11.0268 6.75449 11.0268 8.08821V9.64258",
    stroke: "#64748B",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.449219 9.64258H6.57006",
    stroke: "#64748B",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32617 9.64258H15.447",
    stroke: "#64748B",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIcon);
export default __webpack_public_path__ + "static/media/team-icon.e32ec95100e68a01976eac3f11f896db.svg";
export { ForwardRef as ReactComponent };